import { formsInit } from "./modules/kw-forms";

(() => {
  formsInit();
})();
